import { useProjectDocumentsService } from 'nekst-api';
import React from 'react';
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonVariant,
  useMassUpdateServiceRequired,
  usePopupManager
} from 'ui-builder';
import { useProjectContext } from '../../view/ProjectContext';
import ConfirmWarningActionPopup from '../../../shared/web/popup/ConfirmWarningActionPopup';

export default function RemoveFromPortalButton() {
  const projectDocumentsService = useProjectDocumentsService();
  const popupManager = usePopupManager();

  const massUpdateService = useMassUpdateServiceRequired();

  const value = massUpdateService.getCheckedIds();

  const projectContext = useProjectContext();

  if (massUpdateService.isEnabled()) {
    return (<Button
      text="Remove from Portal"
      size={ButtonSize.SMALL}
      variant={ButtonVariant.FILLED}
      isFlat
      isDisabled={value.length === 0}
      onClick={async () => popupManager.openPopup(<ConfirmWarningActionPopup
        title="Mass Update: Add Documents to Portal"
        message={`Are you sure you want to remove selected documents from the client portal?`}
        submitFormFunc={async () => {
          await projectDocumentsService.removeFromPortal(projectContext.data!.id, value);
        }}
      />)}
      color={ButtonColor.YELLOW}
    />);
  } else {
    return null;
  }

}
